export class PostDocumentError {
  public ErrorCode: string;
  public Message: string;
}
export class PostDocumentErrors {
  public Errors: PostDocumentError[];
}
